import { HttpBackend, HttpClient, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class CustomHttpClientService {
    private http: HttpClient | undefined;

    constructor(private httpBackend: HttpBackend) {}

    initialize(customInterceptors: HttpInterceptor[]) {
        const handler = this.createInterceptorChain(this.httpBackend, customInterceptors);
        this.http = new HttpClient(handler);
    }

    get httpClient(): HttpClient {
        if (this.http) {
            return this.http;
        } else {
            this.initialize([]);
            return this.http!;
        }
    }

    private createInterceptorChain(backend: HttpBackend, interceptors: HttpInterceptor[]): HttpHandler {
        let handler: HttpHandler = backend;

        [...interceptors].reverse().forEach((interceptor) => {
            handler = new InterceptorHandler(handler, interceptor);
        });

        return handler;
    }
}

class InterceptorHandler implements HttpHandler {
    constructor(
        private next: HttpHandler,
        private interceptor: HttpInterceptor,
    ) {}

    handle(req: HttpRequest<any>): Observable<HttpEvent<any>> {
        return this.interceptor.intercept(req, this.next);
    }
}
